'use client';
import React, { memo, useState } from 'react';

import { useLang } from '@/hooks';

import { SIMPLE_DATA } from '../questions.constant';

const QuestionItem = () => {
	const { t } = useLang();
	const [active, setActive] = useState(0);

	const handleActive = (i: number) => {
		setActive(i);
	};
	return (
		<div className="relative lg:mt-10 z-10 max-w-3xl mx-auto">
			{SIMPLE_DATA.map((item, i) => {
				return (
					<div
						key={i}
						className="bg-white flex flex-col shadow-default rounded-default my-[1.5rem]"
					>
						<button
							className="flex justify-start bg-transparent"
							onClick={() => handleActive(i)}
						>
							<p className="text-left text-[15px] p-4 text-gray-11 font-semibold uppercase leading-normal duration-300">
								{t(`${item?.question}`)}
							</p>
						</button>
						<p
							className={`text-[15px] font-normal text-gray-11 px-4 overflow-hidden leading-6 ${
								active === i ? 'h-auto pb-4' : 'h-0'
							} duration-300`}
						>
							{t(`${item?.answer}`)}
						</p>
					</div>
				);
			})}
		</div>
	);
};

export default memo(QuestionItem);
